module.exports = __webpack_public_path__ + "static/media/nectar.75a7038d.svg";